import { render, staticRenderFns } from "./EModalDuplicarAulaInfantil.vue?vue&type=template&id=1b5239fe&scoped=true"
import script from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAulaInfantil.vue?vue&type=style&index=0&id=1b5239fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5239fe",
  null
  
)

export default component.exports